// User = Employee
import {
  AddEmployeeResponse,
  // EmployeeCommonResponse,
  EmployeeError,
  Employee,
  EmployeeResponse,
  DeletedEmployee,
  EmployeeByRoleResponse,
  EmployeeCommonResponse,
  EmployeeProfileResposne,
  ChangePasswordPayload,
  ROLES_NAME,
  TypeResponse,
  TypeData,
  TypeUpdateResponse,
} from '@core/interface/employee';
import { PagePayload } from '@core/interface/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const EmployeeActions = createActionGroup({
  source: 'Employee',
  events: {
    'Load Employees': props<PagePayload>(),
    'Load Employees Success': props<EmployeeResponse>(),
    'Load Employees Failure': props<EmployeeError>(),
    'Add Edit Employee': props<{ employee: Employee }>(),
    'Add Employee Success': props<AddEmployeeResponse>(),
    'Update Employee Success': props<AddEmployeeResponse>(),
    'Add Employee Failure': props<EmployeeError>(),
    'Update Employee Failure': props<EmployeeError>(),
    'Delete Employee': props<{ id: number }>(),
    'Delete Employee Success': props<DeletedEmployee>(),
    'Delete Employee Failure': props<EmployeeError>(),
    'Send Invite': props<{ user_id: number }>(),
    'Send Invite Success': props<AddEmployeeResponse>(),
    'Send Invite Failure': props<EmployeeError>(),
    'Load Employees by role': props<{ role_id: number; roleName: string }>(),
    'Load Employees by role Success': props<{
      employees: EmployeeByRoleResponse;
      roleName: keyof typeof ROLES_NAME;
    }>(),
    'Load Employees by role Failure': props<{
      error: EmployeeError;
      roleName: keyof typeof ROLES_NAME;
    }>(),
    'Employees logout': emptyProps(),
    'Employees logout Success': props<EmployeeCommonResponse>(),
    'Employees logout Failure': props<EmployeeError>(),
    'Employee Profile': emptyProps(),
    'Employee Profile Success': props<EmployeeProfileResposne>(),
    'Employee Profile Failure': props<EmployeeError>(),
    'Change Password': props<ChangePasswordPayload>(),
    'Change Password Success': props<EmployeeCommonResponse>(),
    'Change Password Failure': props<EmployeeError>(),
    'Reset Flags': emptyProps(),

    'Load EmploymentType': emptyProps(),
    'Load EmploymentType Success': props<TypeResponse>(),
    'Load EmploymentType Failure': props<EmployeeError>(),
    'Add Edit EmploymentType': props<TypeData>(),
    'Add EmploymentType Success': props<TypeUpdateResponse>(),
    'Update EmploymentType Success': props<TypeUpdateResponse>(),
    'Add EmploymentType Failure': props<EmployeeError>(),
    'Update EmploymentType Failure': props<EmployeeError>(),

    'Load Work Schedule': emptyProps(),
    'Load Work Schedule Success': props<TypeResponse>(),
    'Load Work Schedule Failure': props<EmployeeError>(),
    'Add Edit Work Schedule': props<TypeData>(),
    'Add Work Schedule Success': props<TypeUpdateResponse>(),
    'Update Work Schedule Success': props<TypeUpdateResponse>(),
    'Add Work Schedule Failure': props<EmployeeError>(),
    'Update Work Schedule Failure': props<EmployeeError>(),

    'Load Work Location': emptyProps(),
    'Load Work Location Success': props<TypeResponse>(),
    'Load Work Location Failure': props<EmployeeError>(),
    'Add Edit Work Location': props<TypeData>(),
    'Add Work Location Success': props<TypeUpdateResponse>(),
    'Update Work Location Success': props<TypeUpdateResponse>(),
    'Add Work Location Failure': props<EmployeeError>(),
    'Update Work Location Failure': props<EmployeeError>(),
  },
});
